import { createApp } from 'vue'
import OrgSearchNrSelect from '../src/pages/admin/org_search/org_search.vue'

const mountVueOrgSearchNrSelect = () => {
  const clickedModal = document.getElementsByClassName('cp-organization')

  $(clickedModal).on('click', function (e) {
    const accountId = e.target.getAttribute('data-account-id')
    const modal = document.getElementById(`cp-organization-id-${accountId}`)
    const selectWrapper = modal?.querySelector(
      '#org-search-nr-select-wrapper'
    ) as HTMLElement

    const app = createApp(OrgSearchNrSelect, { accountId })

    app.mount(selectWrapper)
  })
}

window.mountVueOrgSearchNrSelect = mountVueOrgSearchNrSelect

document.addEventListener('DOMContentLoaded', () => {
  mountVueOrgSearchNrSelect()
})
